import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OrderFromDB } from "./types/OrderAndSocketState";

type OrderNotificationState = {
  unseenOrderIds: string[];
  unseenSessionIds: string[];
  muted: boolean;
  burstCount: number;
};

const initialState: OrderNotificationState = {
  unseenOrderIds: [],
  unseenSessionIds: [],
  muted: false,
  burstCount: 0,
};

const getOrderKey = (order: OrderFromDB) => order.id || String(order.orderNumber);

export const OrderNotificationSlice = createSlice({
  name: "orderNotification",
  initialState,
  reducers: {
    registerNewOrder: (state, action: PayloadAction<OrderFromDB>) => {
      const order = action.payload;
      const orderKey = getOrderKey(order);

      if (!state.unseenOrderIds.includes(orderKey)) {
        state.unseenOrderIds.push(orderKey);
      }

      if (
        order.tableSessionId &&
        !state.unseenSessionIds.includes(order.tableSessionId)
      ) {
        state.unseenSessionIds.push(order.tableSessionId);
      }

      state.burstCount += 1;
    },
    clearBurst: (state) => {
      state.burstCount = 0;
    },
    clearAllOrderNotifications: (state) => {
      state.unseenOrderIds = [];
      state.unseenSessionIds = [];
      state.burstCount = 0;
    },
    markSessionSeen: (state, action: PayloadAction<string>) => {
      state.unseenSessionIds = state.unseenSessionIds.filter(
        (id) => id !== action.payload
      );
    },
    markOrdersSeen: (state, action: PayloadAction<string[]>) => {
      const seen = new Set(action.payload);
      state.unseenOrderIds = state.unseenOrderIds.filter((id) => !seen.has(id));
    },
    toggleOrderNotificationMute: (state) => {
      state.muted = !state.muted;
    },
  },
});

export const {
  registerNewOrder,
  clearBurst,
  clearAllOrderNotifications,
  markSessionSeen,
  markOrdersSeen,
  toggleOrderNotificationMute,
} = OrderNotificationSlice.actions;

export default OrderNotificationSlice.reducer;
